import { createContext } from 'react';

type ShippoTokenContextData = string;

export const ShippoTokenContext = createContext<ShippoTokenContextData | undefined>(undefined);
